import React from "react";
import { useEffect, useState, useRef } from "react";
import NavButton from "../homepage/header-banner/TopNavButton";
import Footer from "../homepage/footer/Footer";
import { Link, useLocation } from "react-router-dom";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import { ChevronRight } from "@mui/icons-material";
import Image1 from "./image/img1.png";
import Image2 from "./image/img2.png";
import Image3 from "./image/img3.png";
import Image4 from "./image/img4.png";
import Image5 from "./image/img5.png";
import Image6 from "./image/img6.png";
import Image7 from "./image/img7.png";
import BgBan from "./image/bg-ban.png";
import Elementglobal from "./image/Element.png";
import Elementglobal2 from "./image/Element-2.png";
import Elementglobal3 from "./image/Element-3.png";
import Elementglobal4 from "./image/Element-4.png";
import Elementglobal5 from "./image/Element-5.png";
import Elementglobal6 from "./image/Element-6.png";
import Elementglobal7 from "./image/Element-7.png";
import FadeInSection from "../container/component/Fadeanimation/FadeInSection";
import LazyMap from "../container/component/map/lazymap";
import "./global-style.css";
import "../Style/typo.css";
import MapAddress from "../hanbirovn/component/map-address";
import langData from "../translations/translations.json";

const ScrollToSection = () => {
    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const section = document.querySelector(location.hash);
            if (section) {
                section.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, [location]);

    return null;
};

function GlobalPage2() {
    const currentLang = "ko";
    const content = langData.headerBan;
    return (
        <div className="global-page2">
            <NavButton
                option={{
                    // logo: logoKube,
                    logo: "https://hanbiro.com/cloud/library/banner/hanbiro.svg",
                    link: "https://hanbiro.com/",
                    color: { backgroundColor: "#7061ff" },
                    itemNavClass: "item-nav nav-pur",
                    menuListProduct: "menu-list-product-item",
                    menuListVora: "vora",
                    menuListGroupware: "groupware",
                    titleTab: "mb-3",
                }}
            />
            <ScrollToSection />
            <div className="header-ban-global">
                <div className="fit-box-gl p-r-l-gl">
                    <FadeInSection>
                        <div className="header-ban-tt-gl">
                            <div className="header-ban-tt-left-gl">
                                <img src="https://hanbiro.com/assets/images/cloud/hanbiro-global/map-6.png" />
                            </div>
                            <div className="header-ban-tt-right-gl">
                                <Link to="#ai-call" className="ban-tt-list-gl">
                                    <div className="ban-tt-icon">
                                        <ChevronRight className="vector-icon wh-color-text" />
                                    </div>
                                    <div className="ban-tt-text-gl wh-color-text">{content["aiSolution"][currentLang]}</div>
                                </Link>
                                <Link to="#microservice" className="ban-tt-list-gl">
                                    <div className="ban-tt-icon">
                                        <ChevronRight className="vector-icon wh-color-text" />
                                    </div>
                                    <div className="ban-tt-text-gl wh-color-text">{content["cloudService"][currentLang]}</div>
                                </Link>
                                <Link to="#kubernetes" className="ban-tt-list-gl">
                                    <div className="ban-tt-icon">
                                        <ChevronRight className="vector-icon wh-color-text" />
                                    </div>
                                    <div className="ban-tt-text-gl wh-color-text">{content["kubernetes"][currentLang]}</div>
                                </Link>
                                <Link to="#ai-groupware" className="ban-tt-list-gl">
                                    <div className="ban-tt-icon">
                                        <ChevronRight className="vector-icon wh-color-text" />
                                    </div>
                                    <div className="ban-tt-text-gl wh-color-text">{content["aiGroupware"][currentLang]}</div>
                                </Link>
                                <Link to="#microservice" className="ban-tt-list-gl">
                                    <div className="ban-tt-icon">
                                        <ChevronRight className="vector-icon wh-color-text" />
                                    </div>
                                    <div className="ban-tt-text-gl wh-color-text">{content["microserviceApi"][currentLang]}</div>
                                </Link>
                            </div>
                        </div>
                    </FadeInSection>
                </div>
            </div>

            <div className="wrap-box-gl global-fea1">
                <div className="fit-box-gl">
                    <FadeInSection>
                        <div className="wrap-title-gl">
                            <p className="typo-32">주요서비스</p>
                        </div>
                    </FadeInSection>

                    <FadeInSection>
                        <div className="wrap-content-fea1-gl">
                            <div className="wrap-ct-box-gl" id="ai-call">
                                <div className="wrap-item">
                                    {/* <div className='fea-tooltip txt-14'><span>&nbsp;</span>AI call 화면캡쳐 (음성추출/대화화면)</div> */}
                                    <p className="fea-title-gl typo-21 typo-medium">AI 통합 그룹웨어솔루션</p>
                                    <div className="fea-content-gr-gl">
                                        <div className="fea-content">
                                            <p className="typo-14">영어•중국어•베트남어•일본어 음성추출 / 요약 및 번역</p>
                                            <p className="typo-14">다국적 임직원의 음성통화 관리</p>
                                            <p className="typo-14">실시간 다국어 메세징 교환</p>
                                        </div>
                                        <div className="fea-btn-gl">
                                            <a class="url-btn-gl" href="https://hanbiro.com/#/groupware-signup-ko">
                                                <button>서비스신청</button>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="wrap-item">
                                    <div className="wrap-item-img-gl">
                                        <img src="https://hanbiro.com/assets/images/cloud/hanbiro-global/crm-rectangle-2.png" />
                                    </div>
                                </div>
                            </div>

                            <div className="wrap-ct-box-gl" id="server">
                                <div className="wrap-item">
                                    {/* <div className='fea-tooltip txt-14'><span>&nbsp;</span>BareMetal 서버이미지</div> */}
                                    <p className="fea-title-gl typo-21 typo-medium">기업전용 클라우드 서버 관리 • 운영</p>
                                    <div className="fea-content-gr-gl">
                                        <div className="fea-content">
                                            <p className="typo-14">전용 서비스 모니터프로그램 24시간운영</p>
                                            <p className="typo-14">전문 서버엔지니어의 관리 · 운영지원</p>
                                            <p className="typo-14">8,000 관계사, 5,000 대의 서버운영 노하우보유</p>
                                        </div>
                                        <div className="fea-btn-gl">
                                            <a class="url-btn-gl" href="https://hanbiro.com/#/server-signup-ko">
                                                <button>서비스신청</button>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="wrap-item">
                                    <div className="wrap-item-img-gl">
                                        <img src="https://hanbiro.com/assets/images/cloud/hanbiro-global/server-rectangle-2.png" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </FadeInSection>

                    <FadeInSection>
                        <div className="wrap-content-fea1-gl" data-aos="fade-up" data-aos-duration="1500">
                            <div className="wrap-ct-box-gl" id="kubernetes">
                                <div className="wrap-item">
                                    {/* <div className='fea-tooltip txt-14'><span>&nbsp;</span>Kubernetes 페이지 이미지</div> */}
                                    <p className="fea-title-gl typo-21 typo-medium">기업전용 쿠버네티스 클러스터 인프라 구축 • 관리</p>
                                    <div className="fea-content-gr-gl">
                                        <div className="fea-content">
                                            <p className="typo-14">서버자원의 효율적인 운영, 리소스의 자동 축소 · 확장</p>
                                            <p className="typo-14">자동재해복구 · 오토스케일링기능, 서비스의 영속성보장</p>
                                            <p className="typo-14">고객사 전용 프라이빗 클러스터 인프라구축, 보안강화</p>
                                        </div>
                                        <div className="fea-btn-gl">
                                            <a class="url-btn-gl" href="https://hanbiro.com/#/server-signup-ko">
                                                <button>서비스신청</button>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="wrap-item">
                                    <div className="wrap-item-img-gl">
                                        <img src="https://hanbiro.com/assets/images/cloud/hanbiro-global/kube-rectangle-2.png" />
                                    </div>
                                </div>
                            </div>

                            <div className="wrap-ct-box-gl" id="ai-groupware">
                                <div className="wrap-item">
                                    {/* <div className='fea-tooltip txt-14'><span>&nbsp;</span>메일 번역/요약화면</div> */}
                                    <p className="fea-title-gl typo-21 typo-medium">기업전용 AI (LLM) 인프라 개발 • 관리운영</p>
                                    <div className="fea-content-gr-gl">
                                        <div className="fea-content">
                                            <p className="typo-14">기업전용 LLM 서버구축, 기업의 독립적인 AI 인프라구축</p>
                                            <p className="typo-14">기업내의 데이터유출 방지•고객데이터 보호</p>
                                            <p className="typo-14">최적의 LLM 모델 적용 및 개발•관리</p>
                                        </div>
                                        <div className="fea-btn-gl">
                                            <a class="url-btn-gl" href="https://hanbiro.com/#/groupware-signup-ko">
                                                <button>서비스신청</button>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="wrap-item">
                                    <div className="wrap-item-img-gl">
                                        <img src="https://hanbiro.com/assets/images/cloud/hanbiro-global/llm-server-rectangle-2.png" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </FadeInSection>

                    <FadeInSection>
                        <div className="wrap-ct-box fea-bottom" id="microservice">
                            <div className="wrap-item">
                                {/* <div className='fea-tooltip txt-14'><span>&nbsp;</span>Event Sourcing 상단이미지사용</div> */}
                                <p className="fea-title-gl typo-21 typo-medium">클라우드기반 마이크로서비스 API 제공</p>
                                <div className="fea-content-gr-gl">
                                    <div className="fea-content">
                                        <p className="typo-14">이벤트 소싱 기반 분산 아키텍처 및 서버리스 시스템 구축</p>
                                        <p className="typo-14">IAM, OAuth, Role 기반 권한 관리로 안전한 Access Control 제공</p>
                                        <p className="typo-14">메시징, Webhook, Scheduler 등 이벤트 기반 자동화 기능 지원</p>
                                    </div>
                                    {/* <div className='fea-btn'>
                                        <button><a class="url-btn" href="https://hanbiro.com/#/server-signup-ko">서비스신청</a></button>
                                    </div> */}
                                </div>
                            </div>
                            <div className="wrap-item">
                                <div className="wrap-item-img-gl">
                                    <img src="https://hanbiro.com/assets/images/cloud/hanbiro-global/microservice-rectangle-2.png" />
                                </div>
                            </div>
                        </div>
                    </FadeInSection>
                </div>
            </div>

            <div className="wrap-box-gl">
                <div className="fit-box-gl">
                    <FadeInSection>
                        <div className="boximage-global">
                            <div className="wrap-title-gl titlebox-global">
                                <p className="typo-32">한비로 베트남 법인 • 연구소</p>
                            </div>
                            <div className="boximage1-global">
                                <div className="listimage-global">
                                    <div className="image1-global">
                                        <img src="https://hanbiro.com/cloud/library/outsourcing/Company 7.png" />
                                    </div>
                                    <div className="image1-global">
                                        <img src="https://hanbiro.com/cloud/library/outsourcing/Company 6.svg" />
                                    </div>
                                    <div className="image1-global">
                                        <img src="https://hanbiro.com/cloud/library/outsourcing/Company 2.svg" />
                                    </div>
                                </div>

                                <div className="listimage2-global">
                                    <div className="image1-global">
                                        <img src="https://hanbiro.com/cloud/library/outsourcing/Company 8.png" />
                                    </div>
                                    <div className="image1-global">
                                        <img src="https://hanbiro.com/cloud/library/outsourcing/Company 3.svg" />
                                    </div>
                                    <div className="image1-global">
                                        <img src="https://hanbiro.com/cloud/library/outsourcing/Company 4.svg" />
                                    </div>
                                </div>
                            </div>

                            <div className="boxcard-global-gr">
                                <div className="boxcard-global">
                                    <div className="card-content-global-gl" data-aos="flip-up" data-aos-duration="1000" data-aos-offset="20">
                                        <div className="card-title-global">
                                            <p className="typo-21-sm typo-medium">MICROSERVICE 개발팀</p>
                                            <p className="typo-14 typo-gray">12 Members</p>
                                        </div>
                                    </div>

                                    <div className="card-content-global-gl" data-aos="flip-up" data-aos-duration="1000" data-aos-offset="20">
                                        <div className="card-title-global">
                                            <p className="typo-21-sm typo-medium">MOBILE 개발팀</p>
                                            <p className="typo-14 typo-gray">7 Members</p>
                                        </div>
                                    </div>

                                    <div className="card-content-global-gl" data-aos="flip-up" data-aos-duration="1000" data-aos-offset="20">
                                        <div className="card-title-global">
                                            <p className="typo-21-sm typo-medium">기업소프트웨어 개발팀</p>
                                            <p className="typo-14 typo-gray">17 Members</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="boxcard-global box2-global">
                                    <div className="card-content-global-gl" data-aos="flip-up" data-aos-duration="1000" data-aos-offset="20">
                                        <div className="card-title-global">
                                            <p className="typo-21-sm typo-medium">그룹웨어 개발팀</p>
                                            <p className="typo-14 typo-gray">12 Members</p>
                                        </div>
                                    </div>

                                    <div className="card-content-global-gl" data-aos="flip-up" data-aos-duration="1000" data-aos-offset="20">
                                        <div className="card-title-global">
                                            <p className="typo-21-sm typo-medium">클라우드서비스 운영팀</p>
                                            <p className="typo-14 typo-gray">15 Members</p>
                                        </div>
                                    </div>

                                    <div className="card-content-global-gl" data-aos="flip-up" data-aos-duration="1000" data-aos-offset="20">
                                        <div className="card-title-global">
                                            <p className="typo-21-sm typo-medium">PL / QC 관리팀</p>
                                            <p className="typo-14 typo-gray">6 Members</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </FadeInSection>
                </div>
            </div>

            <MapAddress lang={currentLang} />

            <Footer
                option={{
                    textColor: "text-color external-link text-pur-color",
                    textlinkColor: "text-color text-pur-color",
                }}
            />
        </div>
    );
}

export default GlobalPage2;
